import { getExecutor } from '../Shared/HttpRequestExecutor';
import { getConfig } from '../Config/ApplicationConfig';
export var searchWitnesses = function (config, patientMedicationId, query, limit) {
    if (query === void 0) { query = ''; }
    if (limit === void 0) { limit = 6; }
    return getExecutor(getConfig().apiEndpoints.medicationsManagement).postCancellable("api/v1/medications/" + patientMedicationId + "/provider-witness?limit=" + limit + "&query=" + query, config);
};
export var searchAuthorisingPrescribers = function (config, patientMedicationId, request, query, limit) {
    if (query === void 0) { query = ''; }
    if (limit === void 0) { limit = 6; }
    return getExecutor(getConfig().apiEndpoints.medicationsManagement).postCancellable("api/v1/medications/" + patientMedicationId + "/authorising-prescriber?limit=" + limit + "&query=" + query, config, request);
};
